import { GuidedLLMError } from './guidedClient';

/** Where a denied generation should send the user. Accepts any GuidedLLMError reason
 *  (network/unknown fall through to a toast). */
export function deniedDestination(reason: GuidedLLMError['reason']): 'paywall' | 'signup' | 'toast' {
  if (reason === 'insufficient_credits') return 'paywall';
  if (reason === 'signup_required') return 'signup';
  return 'toast';
}

/** Central handler for a denied generation. Dispatches a GuidedLLMError to the paywall /
 *  signup / a toast and returns true; returns false for any other error so the caller can
 *  fall back to its own error surface. Keeps every call site's deny handling identical. */
export function routeDenied(
  e: unknown,
  nav: { paywall: () => void; signup: () => void; toast: (message: string) => void },
): boolean {
  if (!(e instanceof GuidedLLMError)) return false;
  const dest = deniedDestination(e.reason);
  if (dest === 'paywall') nav.paywall();
  else if (dest === 'signup') nav.signup();
  // Distinguish an offline device from a busy/unavailable server so the message is
  // actionable rather than a blanket "temporarily unavailable".
  else if (e.reason === 'network') nav.toast('You’re offline — check your connection and try again.');
  else nav.toast('The servers are busy right now — please try again in a moment.');
  return true;
}
